import { useEffect, useState } from 'react'
import axios from 'axios'
import { BrowserRouter } from 'react-router-dom'
import Redirect from 'react-https-redirect'

import { GlobalPopupStyle } from './components/BaseComponents/Popup'
import Router from './components/Routes/Router'

import './styles/fonts.scss'
import { AnalyticsProvider } from './features/Amplitude'
import { useSurvicate } from './utils/sharedHooks'
import { OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import { UsersnapProvider } from './components/shared/UsersnapSurvey'
import { EvervaultProvider } from '@evervault/react'
import { TooltipProvider } from '@/ui'

axios.defaults.baseURL = process.env.VITE_LOCAL_API_ENDPOINT
axios.defaults.withCredentials = true

const App = () => {
  const client = OpenFeature.getClient('openFeatureClient')
  const [cssReady, setCssReady] = useState(false)

  const isDesignSystem2FlagEnabled = client.getBooleanValue(
    'enable-design-system-2',
    false
  )
  // Enables to add and remove css file
  const loadCss = (href: string) => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
  }

  const removeCss = (pattern: string) => {
    document
      .querySelectorAll(`link[href*="${pattern}"]`)
      .forEach((el) => el.remove())
  }

  useEffect(() => {
    if (isDesignSystem2FlagEnabled === null) return

    const init = () => {
      const isDesignSystem2EnvEnabled = process.env.VITE_USE_V2_UI === 'true'

      if (isDesignSystem2FlagEnabled && isDesignSystem2EnvEnabled) {
        console.log('💅 Using Design System 2') // skipcq: JS-0002
        import('./ui.css')
        // 🧼 Cleanup legacy styles
        removeCss('/semantic-ui/semantic.min.css')
        removeCss('/legacy.scss')
        removeCss('vendor-')
        setCssReady(true)
      } else {
        console.log('📼 Using Legacy Design System') // skipcq: JS-0002
        import('./legacy.scss')
        loadCss('/semantic-ui/semantic.min.css')
        // 🧼 Cleanup DSM2 styles
        removeCss('ui-')
        setCssReady(true)
      }
    }

    init()
  }, [isDesignSystem2FlagEnabled])
  useSurvicate()

  return cssReady ? (
    <div className="App" id="App">
      <EvervaultProvider
        teamId={process.env.VITE_EVERVAULT_TEAM_ID ?? ''}
        appId={process.env.VITE_EVERVAULT_APP_ID ?? ''}
      >
        <OpenFeatureProvider domain="openFeatureClient">
          <AnalyticsProvider>
            <UsersnapProvider>
              <TooltipProvider>
                <GlobalPopupStyle />
                <Redirect disabled={process.env.NODE_ENV === 'development'}>
                  <BrowserRouter>
                    <Router />
                  </BrowserRouter>
                </Redirect>
              </TooltipProvider>
            </UsersnapProvider>
          </AnalyticsProvider>
        </OpenFeatureProvider>
      </EvervaultProvider>
    </div>
  ) : null
}

export default App
